// extracted by mini-css-extract-plugin
export var linkText = "_ns-0";